const infiniteScrollActionsTypes = {
    SET_MAX_SCROLL_TOP: "SET_MAX_SCROLL_TOP"
};

export default infiniteScrollActionsTypes;